import { styled } from "styled-components";

export const Container = styled.div`
  display: flex;
  width: 100%;
  padding: 0 8px 40px 8px;
  flex-direction: column;
  align-items: center;
  background: #f7f8f9;

  .flex1 {
    flex: 1 0 0;
  }
`;

export const Header = styled.div`
  display: flex;
  padding: 24px 8px 16px 8px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
`;

export const StepWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 3px;
  align-self: stretch;
`;

export const Step = styled.div<{ $active?: boolean }>`
  display: flex;
  padding: 4px 8px;
  justify-content: center;
  align-items: center;
  border-radius: 100px;
  background: #e5eaf0;

  color: rgba(23, 30, 38, 0.56);
  text-align: center;
  font-family: Pretendard;
  font-size: 12px;
  font-weight: 500;
  line-height: 14px; /* 116.667% */

  ${({ $active }) =>
    $active &&
    `
  background: #166F4D;
  color: #fff;
`}
`;

export const StepDivider = styled.div`
  width: 8px;
  height: 1px;
  background: #c6d0dd;
`;

export const Title = styled.div`
  color: #171e26;
  font-size: 20px;
  font-weight: 700;
  line-height: 145%; /* 29px */
  letter-spacing: -0.2px;
`;

export const Address = styled.div`
  color: rgba(23, 30, 38, 0.78);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 142.857% */
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
`;

export const GreenBox = styled.div`
  display: flex;
  padding: 16px;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  border-radius: 8px;
  background: #eaf8f2;

  color: #166f4d;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 142.857% */
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  border-radius: 8px;
  background: #fff;
`;

export const SectionTitleContainer = styled.div`
  display: flex;
  padding: 16px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
`;

export const SectionTitle = styled.div`
  flex: 1 0 0;
  color: #171e26;
  font-size: 18px;
  font-weight: 700;
`;

export const UnitWrapper = styled.div`
  position: relative;
`;

export const UnitChangeButton = styled.button`
  cursor: pointer;
  border: none;
  outline: none;

  display: flex;
  padding: 4px 12px;
  align-items: center;
  gap: 2px;
  border-radius: 1699px;
  background: #f0f0f0;
  color: rgba(23, 30, 38, 0.78);
  font-size: 14px;
  font-weight: 500;
  line-height: 20px; /* 142.857% */

  & > span {
    color: rgba(23, 30, 38, 0.56);
    font-size: 14px;
    font-weight: 500;
    line-height: 20px; /* 142.857% */
  }
`;

export const UnitChangeDropdown = styled.div`
  position: absolute;
  top: calc(100% + 8px);
  right: 16px;
  z-index: 1000;

  display: flex;
  width: 160px;
  padding: 4px;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 16px;
  border: 1px solid var(--Alias-Color-Line-Outline, rgba(23, 30, 38, 0.1));
  background: var(--Alias-Color-Background-Seciton, #fff);

  /* shadow/light/+Y/02 */
  box-shadow:
    0 4px 12px 0 rgba(39, 44, 54, 0.05),
    0 2px 4px 0 rgba(39, 44, 54, 0.12),
    0 8px 32px 0 rgba(39, 44, 54, 0.08);
`;

export const UnitChangeDropdownItem = styled.div<{ $active?: boolean }>`
  display: flex;
  cursor: pointer;
  padding: 8px 12px;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  justify-content: space-between;

  color: rgba(23, 30, 38, 0.56);
  font-size: 14px;
  font-weight: 500;
  line-height: 20px; /* 142.857% */

  ${({ $active }) => $active && "color: #171E26"}
`;

export const SectionInner = styled.div<{ $top?: number }>`
  display: flex;
  padding: 4px 16px 16px 16px;
  padding-top: ${({ $top }) => ($top ? `${$top}px` : "4px")};
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
`;

export const Label = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;
  color: rgba(23, 30, 38, 0.56);
  font-family: "Spoqa Han Sans Neo";
  font-size: 13px;
  font-weight: 500;
  line-height: 145%; /* 18.85px */
  letter-spacing: -0.26px;
`;

export const LabelTitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;
  color: var(--Alias-Color-Text-Dark-Text-Secondary, rgba(23, 30, 38, 0.78));
  font-family: Pretendard;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px; /* 142.857% */
`;

export const ChangeInputUnit = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;

  color: rgba(23, 30, 38, 0.78);
  font-size: 14px;
  font-weight: 500;
  line-height: 20px; /* 142.857% */
`;

export const InputMessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;
`;

export const InputWrapper = styled.div<{ $error?: boolean }>`
  flex: 1 0 0;
  min-width: 0;
  display: flex;
  padding: 8px 12px;
  align-items: center;
  gap: 4px;
  align-self: stretch;
  border-radius: 8px;
  border: 1px solid rgba(23, 30, 38, 0.1);
  background: #fff;

  color: rgba(23, 30, 38, 0.78);
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;

  ${({ $error }) => $error && "border-color: #D84836"};
`;

export const InputMessage = styled.div`
  padding: 0 12px;
  color: var(--Alias-Color-Text-Dark-Text-Tertiary, rgba(23, 30, 38, 0.56));

  /* Spoqa/Body/13_Medium */
  font-family: "Spoqa Han Sans Neo";
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: 145%; /* 18.85px */
  letter-spacing: -0.26px;
`;

export const InputWarningMessage = styled(InputMessage)`
  color: #0c64ce;
`;

export const InputErrorMessage = styled(InputMessage)`
  color: #d84836;
`;

export const Input = styled.input`
  outline: none;
  border: none;
  background-color: transparent;
  flex: 1 0 0;
  min-width: 0;
  color: #171e26;
  font-size: 14px;
  font-weight: 500;
  line-height: 24px; /* 171.429% */

  &::placeholder {
    color: rgba(23, 30, 38, 0.4);
  }
`;

export const Checkbox = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  align-self: stretch;

  color: rgba(23, 30, 38, 0.78);
  font-family: Pretendard;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px; /* 142.857% */
`;

export const FixedValue = styled.div`
  display: flex;
  padding: 8px 0;
  align-items: center;
  gap: 2px;
  align-self: stretch;
  border-bottom: 1px solid rgba(23, 30, 38, 0.1);

  color: rgba(23, 30, 38, 0.78);
  font-family: Pretendard;
  font-size: 16px;
  font-weight: 500;
  line-height: 150%; /* 24px */
`;

export const OptionWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
`;

export const Option = styled.button<{ $active?: boolean }>`
  border: none;
  outline: none;
  cursor: pointer;
  display: flex;
  padding: 10px 16px;
  justify-content: center;
  align-items: center;
  flex: 1 0 0;
  border-radius: 8px;
  background: 200, #f0f0f0;
  color: rgba(23, 30, 38, 0.4);
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 142.857% */

  ${({ $active }) =>
    $active &&
    `
    background:  #166F4D;
    color:  #FFF;
    font-weight: 700;
`}
`;

export const Stepper = styled.div`
  display: flex;
  height: 36px;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  min-width: 0;
  width: 100%;
`;

export const StepButton = styled.button`
  border: none;
  outline: none;
  cursor: pointer;

  display: flex;
  width: 36px;
  height: 36px;
  padding: 8px;
  justify-content: center;
  align-items: center;
  gap: 2px;
  border-radius: 8px;
  background: #f0f0f0;
`;

export const StepTextButton = styled.button<{ $bg?: string; $color?: string }>`
  border: none;
  outline: none;
  cursor: pointer;

  display: flex;
  height: 36px;
  padding: 8px 12px;
  justify-content: center;
  align-items: center;
  gap: 2px;
  border-radius: 8px;
  background: ${({ $bg }) => $bg ?? "#fff"};
  color: ${({ $color }) => $color ?? "#222"};
  font-size: 14px;
  font-weight: 700;
  line-height: 20px; /* 142.857% */
`;

export const StepperInner = styled.div<{ $isFixed?: boolean }>`
  display: flex;
  padding: 6px 16px;
  justify-content: center;
  align-items: center;
  gap: 2px;
  flex: 1 0 0;
  min-width: 0;
  align-self: stretch;
  border-radius: 8px;
  border: 1px solid var(--Alias-Color-Line-Outline, rgba(23, 30, 38, 0.1));
  background: var(--White, #fff);
  color: var(--Alias-Color-Text-Dark-Text-Secondary, rgba(23, 30, 38, 0.78));
  font-size: 14px;
  font-weight: 500;
  line-height: 20px; /* 142.857% */

  ${({ $isFixed }) => $isFixed && "border:none;"}
`;

export const StepperInput = styled(Input).attrs({
  type: "text",
  inputMode: "decimal", // 모바일 숫자/소수점 키패드
  pattern: "[0-9.]*", // 숫자 + . 만 허용
})`
  text-align: right;
`;

export const StepperUnit = styled.div`
  flex: 1 0 0;
  min-width: 0;
`;

export const Button = styled.button`
  border: none;
  outline: none;
  cursor: pointer;

  display: flex;
  padding: 12px 0;
  justify-content: center;
  align-items: center;
  gap: 2px;
  align-self: stretch;
  border-radius: 8px;
  background: #f0f0f0;
  color: rgba(23, 30, 38, 0.56);
  font-size: 14px;
  font-weight: 500;
  line-height: 20px; /* 142.857% */
`;

export const AddButton = styled.button`
  border: none;
  outline: none;
  cursor: pointer;

  display: flex;
  padding: 16px;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  align-self: stretch;
  border-radius: 8px;
  background: var(--Alias-Color-Text-White-Gray-LightGray-200, #f0f0f0);
  color: var(--Alias-Color-Text-Dark-Text-Secondary, rgba(23, 30, 38, 0.78));

  /* Mo/Body/S-14-Medium */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 142.857% */
`;

export const Accordian = styled.div`
  padding: 8px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 2px;
  align-self: stretch;
  border-bottom: 1px solid rgba(23, 30, 38, 0.1);
  cursor: pointer;
  color: rgba(23, 30, 38, 0.78);
  font-size: 16px;
  font-weight: 700;
  line-height: 150%; /* 24px */
`;

export const Arrow = styled.img<{ $open: boolean }>`
  transition: transform 200ms ease;
  transform: rotate(${({ $open }) => ($open ? 90 : -90)}deg);
`;

export const NextButton = styled.button`
  border: none;
  outline: none;
  cursor: pointer;

  display: flex;
  padding: 12px 24px;
  justify-content: center;
  align-items: center;
  gap: 2px;
  align-self: stretch;
  border-radius: 8px;
  background: #e5eaf0;
  color: var(--Global-Color-BlueGray-700, #3d5066);
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px; /* 142.857% */
`;

export const SliderContainer = styled.div`
  position: relative;
  display: flex;
  margin-bottom: 32px;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  align-self: stretch;
`;

export const SliderValue = styled.div`
  position: absolute;
  top: 38px;
  transform: translateX(-50%);

  color: var(--Alias-Color-Text-Dark-Text-Primary, #171e26);

  /* Mo/Body/L-16-Bold */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%; /* 24px */
`;

export const SelectContainer = styled.div`
  position: relative;
  align-self: stretch;
`;

export const Select = styled.div<{ $active?: boolean }>`
  cursor: pointer;
  display: flex;
  padding: 8px 12px;
  align-items: center;
  gap: 4px;
  align-self: stretch;
  border-radius: 8px;
  border: 1px solid var(--Alias-Color-Line-Outline, rgba(23, 30, 38, 0.1));
  background: var(--White, #fff);

  ${({ $active }) => $active && `border-color: #1E9B6B`};

  & > .select-label {
    color: rgba(23, 30, 38, 0.78);
    font-size: 14px;
    font-weight: 500;
    line-height: 24px; /* 171.429% */
  }
`;

export const SelectLabelDesc = styled.div`
  flex: 1 0 0;
  color: var(--Alias-Color-Text-Dark-Text-Tertiary, rgba(23, 30, 38, 0.56));
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px; /* 171.429% */
`;

export const SelectDropdown = styled.div`
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  z-index: 1000;

  display: flex;
  width: 100%;
  padding: 4px;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 16px;
  border: 1px solid var(--Alias-Color-Line-Outline, rgba(23, 30, 38, 0.1));
  background: var(--Alias-Color-Background-Seciton, #fff);

  /* shadow/light/+Y/02 */
  box-shadow:
    0 4px 12px 0 rgba(39, 44, 54, 0.05),
    0 2px 4px 0 rgba(39, 44, 54, 0.12),
    0 8px 32px 0 rgba(39, 44, 54, 0.08);
`;

export const DropdownItem = styled.div<{ $active?: boolean }>`
  cursor: pointer;
  display: flex;
  padding: 8px 12px;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  color: var(--Alias-Color-Text-Dark-Text-Tertiary, rgba(23, 30, 38, 0.56));
  font-size: 14px;
  font-weight: 500;
  line-height: 20px; /* 142.857% */
  white-space: pre-line;
  ${({ $active }) => $active && "color: #171E26"}
`;
